import { render, staticRenderFns } from "./forbidden.vue?vue&type=template&id=32f35942&scoped=true&"
import script from "./forbidden.vue?vue&type=script&lang=ts&"
export * from "./forbidden.vue?vue&type=script&lang=ts&"
import style0 from "./forbidden.vue?vue&type=style&index=0&id=32f35942&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f35942",
  null
  
)

export default component.exports